<template>
<div>

	<section>
		<div class="row-align">
		<div class="print-position">
				<button class="print-button print-color button" @click="downloadCatalog()"> <img class="img-font-size mr-2 mb-1" id="" src="../../../assets/images/u224.svg"/> Download  </button>
		</div>
		<div class="row mb-3 " v-if="organization_hours != '' && !get_hide_purchased_hour ">
			<div class="top-item">
				<div class="bold-title">
				<img class="img-font-size mb-1" id="" src="../../../assets/images/access_time_u27.svg"/> {{secondsToHms(organization_hours.purchased.sec,true)}}
				</div>
			</div>
			<div class="top-item padding-cart-top">
				<div class="cart-bar">
					<div class="cart-bar-progress" v-bind:style="{ width:left_hours_percentage + '%' }"></div>
				</div>
			</div>
			<div class="blue-text top-item">
				<img class="img-font-size" id="" src="../../../assets/images/u24_circle.svg"/> {{secondsToHms(organization_hours.spent.sec, true)}}

			</div>
			<div class="grey-text top-item">
				<img class="img-font-size" id="" src="../../../assets/images/u25_circle.svg"/>  {{secondsToHms(organization_hours.left.sec, true)}}
				left
			</div>
			
		
		</div>
		
		<div class="row mb-2 mt-2">
			<div class="search-wrapper">
				<img class="img-font-size icon-search" id="" src="../../../assets/images/search_icon_u33.svg"/>
				 <input type="text" class="search-section" v-model="search" @keyup="searchTrigger(search)"  placeholder="Search" />
			</div>	
           
        </div>
		</div>

        <div class="row justify-content-around top-margin margin-10">
            <div class="" v-for="(course, index) in courses" :key="index">
				<router-link tag="a" :to="{ name : 'organization.courses.detail', params : { id : course.id, section:'program' } }" class="d-flex justify-content-center align-items-center">
				<div class="rectangle-outside">
						<a class="pointer">
						<div class="rectangle-holder">
							<div class="rectangle-wrapper">
								<div class="title-rectangle bold-title">
									 {{course.name}}
								</div>
								<!-- <div class="rectangle-notes">
									{{course.notes}}
								</div> -->
								<div class="blue-time-date-drafts blue-text">
									
									<img class="img-font-size mb-1" id="" src="../../../assets/images/access_time_u51.svg"
                                                /> 	{{secondsToHms(course.duration, true)}} <span class="float-right grey-text">ID {{course.id}}</span>
								   <!-- <div class="person-section">
										<img class="img-font-size" id="" src="../../../assets/images/u14_person.svg"
                                                />
									</div> -->
								</div>
							</div>
						</div>
					</a>
				</div>
				</router-link>
                <!-- <div class="banner d-flex rounded">
                	<div class="d-flex justify-content-center align-items-center">
	                	<div class="thumb-container" :style="{ 'background-image' : 'url('+course.image+')' }"></div>
	                	<div class="caption">
		                	<div class="title">{{ course.name }}</div>
		                	<div class="subtitle">{{ course.description }}</div>
	                	</div>
                	</div>
                </div> -->
            </div><!--col-->   
			    <i aria-hidden="true"></i>
                <i aria-hidden="true"></i>
        </div><!--row-->
	</section>
</div>
</template>

<script>
import MixinSME from '../../sme/MixinSME';
	export default{
		mixins: [MixinSME],
		data : function(){
			return {
				courses : [],
				download_token: this.$store.getters.getDownloadToken,
				temp_current_org: this.$store.getters.getCurrentOrganization,
				completion:10,
				search:'',
				current_page:1,
				organization_hours:''

			}
		},
		computed:{
		
		},
		watch:{
			get_current_org: function(val){
				if(val == this.temp_current_org){
					return
				}else{
					this.temp_current_org = val
					this.getCourses();
					this.getHours();
				}
			},
		},
		created : function(){
			this.getCourses();
			this.getHours();
		},
		computed:{
			left_hours_percentage: function(){
				return Math.round((this.organization_hours.spent.sec / this.organization_hours.purchased.sec)*100)
			},
			get_current_org: function(){
				return this.$store.getters.getCurrentOrganization
			},
			get_hide_purchased_hour: function(){
				return this.$store.getters.getHidePurchasedHour
			},

		},
		methods : {
			searchTrigger: function(search){
				clearTimeout(this.timeout);
				this.timeout = setTimeout( () => {
					this.getCourses()
				},2000)
			},
			getCourses : function(){
				var params = {
					filters : {
						page : this.current_page,
						search:this.search,
					}
				}
				this.$store.dispatch('getCourses', params).then((res) => {
					this.courses = res.data.data;

				}).catch((error) => {
					console.log(error);
				});
			},
			getHours : function(){
				var params = {

				}

				this.$store.dispatch('getOrganizationHours', params).then((res) => {
					this.organization_hours = res.data.data
				}).catch((error) => {
					console.log(error);
				});
			},
			downloadCatalog: function(){
				var params = {
					id: '_',
					filters : {
						download_token: this.download_token
					}
				}
				this.$store.dispatch('downloadProgramsAllZip', params).then((res) =>{
					var url = this.config.DOWNLOAD_PROGRAM_CATALOG_ZIP.replace('%ORG_ID%', this.id);
					url = url + '?download_token='+this.download_token;
					window.open(url, '_self');
					
				})

		}
		}
	}
</script>
<style scoped>
*{
	text-decoration: none !important;
}
i{
    width: 404px;
    /* height: 290px; */
}
.rectangle-outside{
	width: 380px;
	height: 104px;
	border-radius: 4px;
	background-color: #ffffff;
	box-sizing: border-box;
	font-family: 'Arial Regular', 'Arial', sans-serif;
	color: #333333;
	text-align: left;
	line-height: normal;
	box-shadow: 0px 2px 5px 0px rgba(0, 0, 0, 0.35);
	margin-right: 25px;
	margin-bottom: 25px;
}
.rectangle-holder{
	border-width: 0px;
    /* position: absolute;
    left: 16px;
    top: 0px; */
    width: 380px;
    height: 104px;
    display: flex;
}
.rectangle-wrapper{
	/* border-width: 0px; */
    /* position: absolute;
    left: 0px;
    top: 0px; */
	padding: 16px 16px 16px 16px;
    width: 100%;
    min-height: 104px;
    max-height: auto !important;
    background: inherit;
    /* background-color: rgba(255, 255, 255, 1); */
    border: none;
    border-radius: 4px;
    
}
.bold-title{
 	font-weight: 500;
    font-style: normal;
    font-size: 18px;
    color: #555555;
	font-family: 'Gilroy Bold', 'Gilroy', sans-serif;

}
.top-col{
	max-width: 188px !important;
    width: 188px;
	
}
.cart-bar{
	border-width: 0px;
    /* position: absolute;
    left: 0px;
    top: 0px; */
	max-width: 188px !important;
    width: 188px;
    height: 12px;
    background: inherit;
    background-color: rgba(215, 215, 215, 1);
    border: none;
    border-radius: 66px;
    -moz-box-shadow: none;
    -webkit-box-shadow: none;
    box-shadow: none;
}
.cart-bar-progress{
	border-width: 0px;
    height: 12px;
    background: inherit;
    background-color: rgba(17, 165, 167, 1);
    border: none;
    border-radius: 66px;
    -moz-box-shadow: none;
    -webkit-box-shadow: none;
    box-shadow: none;
}
.padding-cart-top{
	padding-top: 6px;
}
.row-align{
	margin-left: 35px
}
.icon-search{
	width: 16px;
    height: 16px !important;
    position: absolute;
	margin-top: 13px;
	margin-left:3px;
}
.title-rectangle{
   
    line-height: 20px;
	border-width: 0px;
	flex-wrap: wrap;
    word-wrap: break-word;
    text-transform: none;
    -webkit-line-clamp: 3; /* number of lines to show */
    overflow: hidden !important;
    /* white-space: nowrap; */
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
	max-height: 58px;
	height: 58px;
	width: 100%;
}
.blue-text{
	font-family: 'Gilroy', sans-serif;
    font-weight: 400;
    font-style: normal;
    font-size: 16px;
    color: #11A5A7;
    line-height: 20px;
}
.grey-text{
	font-family: 'Gilroy', sans-serif;
    font-weight: 400;
    font-style: normal;
    font-size: 16px;
    color: #AAAAAA;
}
.blue-time-date-drafts {
    /* width: 260px; */
    height: 22px;
    box-sizing: border-box;
    text-align: left;
    position: relative;
    bottom: 0px;
	
} 
.person-section{
	position: relative;
    bottom: 4px;
	padding:2px;
	padding-left: 5px;
	float: right;
	border-width: 0px;
    width: 57px;
    height: 24px;
    background: inherit;
    background-color: rgba(225, 242, 242, 1);
    border: none;
    border-radius: 32px;
    -moz-box-shadow: none;
    -webkit-box-shadow: none;
    box-shadow: none;
}
.top-item{
	margin: 5px;
}
.search-wrapper{
	margin-left: 4px;
	width: 95%;
    height: 40px;
    background: inherit;
    background-color: rgba(242, 242, 242, 0);
    box-sizing: border-box;
    border-width: 1px;
    border-style: solid;
    border-color: rgba(215, 215, 215, 1);
    border-left: 0px;
    border-top: 0px;
    border-right: 0px;
    border-radius: 8px;
    border-bottom-right-radius: 0px;
    border-bottom-left-radius: 0px;
    -moz-box-shadow: none;
    -webkit-box-shadow: none;
    box-shadow: none;
    font-family: 'Gilroy', sans-serif;
    font-weight: 400;
    font-style: normal;
    font-size: 16px;
    letter-spacing: 0.4px;
    color: #333333;
}
.search-section:hover{
	background-color: rgba(85,85,85, 0.09);
	border-radius: 8px;
}
.search-wrapper:hover{
	border-bottom: 0px;
}

.search-section{

    width: 100%;
    height: 40px;
    padding: 2px 2px 2px 32px;
    font-family: 'Gilroy', sans-serif;
    font-weight: 400;
    font-style: normal;
    font-size: 16px;
    letter-spacing: 0.4px;
    color: #999999;
    vertical-align: none;
    text-align: left;
    text-transform: none;
    background-color: transparent;
    border-color: transparent;
}
.top-margin{
	margin-top: 3%;
}
.margin-10{
	margin-right: 10px;
	margin-left: 10px;
}
.print-button{
	padding: 4px;
	border-width: 0px;
    width: 130px;
    height: 40px;
    background: inherit;
    background-color: rgba(207, 237, 237, 1);
    border: none;
    border-radius: 4px;
}
.print-position{
	float: right;
    position: relative;
    top: -6px;
    left: -40px;
}
.print-color{
	font-family: 'Gilroy', sans-serif;
    font-weight: 400;
    font-style: normal;
    font-size: 16px;
    color: #109B9B;
    line-height: 20px;
}
</style>


// WEBPACK FOOTER //
// src/components/organizations/courses/OrganizationCourseListComponent.vue